<template>
    <div>{{ status }}</div>
</template>

<script>
export default {
    data() {
        return {
            status: 'Authorizing...',
        }
    },

    async mounted () {
        try {
            const token = this.$route.query.token
            if (!token) {
                throw new Error('Es ist ein Fehler aufgetreten.')
            }

            this.$store.commit('setAccessToken', token)
            await this.$router.push({ name: 'Home' })
        } catch (e) {
            this.status = e?.message || 'An error occurred'
            console.log(e)
        }
    },
}
</script>
